import script from "./SessionOpenPlacesMixin.vue?vue&type=script&lang=js"
export * from "./SessionOpenPlacesMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__